import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';

@Directive({
    selector: '[autofocus]',
})
export class AutofocusDirective {
    @Input() autofocus = false;

    constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

    ngOnInit() {
        const elm = this.elementRef.nativeElement;
        if (this.autofocus) {
            this.renderer.setProperty(elm, 'focus', true);
            /* Trick to prevent Firefox put the cursor at the beggining of the input */
            const value = elm.value;
            elm.value = '';
            elm.value = value;
        }
    }
}
